export const API_GET_VOUCHER_AUTHORIZED = "/comprobantes/autorizados/";

export const API_GET_SEARCH_AUTHORIZED='/comprobantes/autorizados/busqueda/';
